enum TiposCalculoEmbalagem {
    Unitario = 0,
    Total = 1
}

export default TiposCalculoEmbalagem;